import { BooleanType } from '@convergence/types';
import { valueFromTreeAndPath } from './util';
import { AnalysisValueProps } from './types';
import { Check, X } from '@phosphor-icons/react';

export function AnalysisBoolean(props: AnalysisValueProps<BooleanType>) {
  const value = valueFromTreeAndPath<boolean>(props.tree, props.propertyPath);

  return (
    <div>
      <label className="py-2 border-l flex gap-2 items-center w-full justify-between border-b-black border-b">
        {props.name}:{value ? <Check /> : <X />}
      </label>
    </div>
  );
}
